export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择商店"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未命名"])}
}